import General from "./General.vue";
import Register from "./Register";
import Attach from "./Attach";
import Water from "./Water.vue";
import Mail from "./Mail.vue";
import Sterling from "./Sterling";
import Menus from "./Menus.vue";

module.exports = [
    {path: '/settings/general', component: General, meta: {title: 'General Settings'}},
    {path: '/settings/register', component: Register, meta: {title: 'Registration Settings'}},
    {path: '/settings/attach', component: Attach, meta: {title: 'Attachment Settings'}},
    {path: '/settings/water', component: Water, meta: {title: 'Watermark Settings'}},
    {path: '/settings/mail', component: Mail, meta: {title: 'Mail Settings'}},
    {path: '/settings/sterling', component: Sterling, meta: {title: 'Sterling'}},
    {path: '/settings/menus', component: Menus, meta: {title: 'Menus'}},
]